
import { EdgeFunctionCaller } from '@/components/edge-function/edge-function-caller';
import { Separator } from "@/components/ui/separator";

export function SectionDeveloper() {
    return (
        <div className="space-y-6">
            <div>
                <h2 className="text-2xl font-semibold tracking-tight">Developer</h2>
                <p className="text-muted-foreground">
                    Tools for developers and advanced debugging.
                </p>
            </div>
            <Separator />

            <div className="space-y-6">
                <EdgeFunctionCaller />
            </div>
        </div>
    );
}
